'use strict';

angular.module('shiftTraderApp')
  .directive('saWorkHourDistributionBar', ['TimeService', '$timeout', '$filter', 'uuid4', function (TimeService, $timeout, $filter, uuid4) {
    var baseTemplate = '<div class="sa_work_hour_distribution_bar"></div>';

    return {
      template: baseTemplate,
      restrict: 'A',
      scope: {
        data: '=',
        eventPrefix: '@',
        max: '='
      },
      link: function(scope, elem) {
        var rowId = uuid4.generate();

        var prepData = function() {
          scope.d3Data = [];
          var maxVal;

          if (_.isUndefined(scope.max)) {
            maxVal = _.max(scope.data);
          } else {
            maxVal = scope.max;
          }
          _.each(scope.data, function(datum, idx) {
            var mins = idx * 30;
            scope.d3Data.push({
              minutes: mins,
              density: datum / maxVal,
              timeLabel: TimeService.minutesToTimeString(mins, true),
              numTimes: $filter('number')(datum / 1800, 1)
            });
          });
        };

        var setupChart = function() {

          scope.chart = {
            elem: $(elem).find('.sa_work_hour_distribution_bar')[0],
            margin: {top: 0, right: 0, bottom: 0, left: 0},
            tip: null,
            svg: null
          };

          $(scope.chart.elem).empty();
          $('body').find('#d3-tip-' + rowId).remove();

          var tempWidth = $(scope.chart.elem).outerWidth();
          if (tempWidth < 50) {
            tempWidth = 300;
          }
          scope.chart.height = 30 - scope.chart.margin.top - scope.chart.margin.bottom;
          scope.chart.width = tempWidth - scope.chart.margin.left - scope.chart.margin.right;
          scope.chart.x = d3.scale.ordinal()
            .rangeBands([0, scope.chart.width], 1.0 / 48);

          scope.chart.xAxis = d3.svg.axis()
            .scale(scope.chart.x)
            .orient("bottom");

          scope.chart.y = d3.scale.linear()
            .range([scope.chart.height, 0]);

          scope.chart.tip = d3.tip()
            .attr('class', 'd3-tip')
            .attr('id', 'd3-tip-' + rowId)
            .offset([-10, 0])
            .html(function(d) {
              return "<strong>" + d.timeLabel + "</strong> <span class=\"blue_text\">" + d.numTimes + "</span><span class=\"gray_text\"> shifts</span>";
            });

          scope.chart.svg = d3.select(scope.chart.elem).append("svg")
            .attr("width", scope.chart.width + scope.chart.margin.left + scope.chart.margin.right)
            .attr("height", scope.chart.height + scope.chart.margin.top + scope.chart.margin.bottom)
            .append("g")
            .attr("transform", "translate(" + scope.chart.margin.left + "," + scope.chart.margin.top + ")");

          scope.chart.svg.call(scope.chart.tip);

          scope.chart.x.domain(scope.d3Data.map(function(d) { return d.minutes; }));
          scope.chart.y.domain([0, 1]);

          scope.chart.svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + scope.chart.height + ")")
            .call(scope.chart.xAxis);

          //svg.append("g")
          //  .attr("class", "y axis")
          //  .call(yAxis)
          //  .append("text")
          //  .attr("transform", "rotate(-90)")
          //  .attr("y", 6)
          //  .attr("dy", ".71em")
          //  .style("text-anchor", "end")
          //  .text("Frequency");

        };

        var drawChart = function() {
          scope.chart.svg.selectAll(".bar")
            .data(scope.d3Data)
            .enter().append("rect")
              .attr("class", "bar")
              .attr("x", function(d) { return scope.chart.x(d.minutes); })
              .attr("width", scope.chart.x.rangeBand())
              .attr("y", 0)
              .attr("height", scope.chart.height)
              .attr("fill", function(d) {
                var z = 0;
                var opacity = 1;
                if (d.density && d.density > 0) {
                  z = d.density;
                }

              if (z === 0) {
                opacity = 1.0;
              }

              var q = Math.floor(235 * (1.0 - z)) + 20;

              return 'rgba(' + q + ',' + q + ',' + q + ',' + opacity + ')';
                //return 'rgba(0,' + Math.floor(z* 179) + ',' + Math.floor(z * 181) + ',' + opacity + ')';
              })
              .on('mouseover', scope.chart.tip.show)
              .on('mouseout', scope.chart.tip.hide);
        };


        $timeout(function() {
          prepData();
          setupChart();
          drawChart();
        }, 100);


        var eventName = (scope.eventPrefix ? (scope.eventPrefix + ':') : '') + 'analyticsDataChanged:redraw';
        scope.$on(eventName, function() {
          $timeout(function() {
            prepData();
            setupChart();
            drawChart();
          }, 250);
        }, true);


        scope.$on('$destroy', function() {
          $('body').find('#d3-tip-' + rowId).remove();
        });
      }
    };
  }]);
